 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		39: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~pages-account~pages-auth-Login~pages-auth-SSOLogin~pages-auth-SignUp~pages-auth-VerifyTwoFac~59cc25bd","1":"vendors~CurationUploaderAdd~Uploader-DesignUploaderOverlayAdd~activity~components-ProfilePage~fileOv~27520fdb","2":"vendors~activity~components-YourLevelPage~fileOverlay-FileOverlay~files~pages-auth-VerifyTwoFactor-V~403f6b55","3":"vendors~CurationUploaderAdd~CurationUploaderEdit~NationBuilderPreferencesPage~Uploader-DesignUploade~08d5fba3","4":"vendors~CurationUploaderAdd~CurationUploaderEdit~Uploader-DesignUploaderOverlayAdd~Uploader-DesignUp~4c14269d","5":"vendors~CurationUploaderAdd~Uploader-DesignUploaderOverlayAdd~activity~components-ProfilePage~files","6":"NationBuilderPreferencesPage~PreziPreferences~SquarePreferences~SquarespacePreferences","7":"vendors~activity~fileOverlay-FileOverlay~pages-handover-messages~pages-messages","8":"vendors~components-PasswordPage~components-PersonalInformationPage~components-ProfessionalBackground~5190a00c","9":"components-PasswordPage~components-PersonalInformationPage~components-ProfessionalBackgroundPage","10":"pages-auth-Login~pages-auth-SignUp~pages-auth-VerifyTwoFactor-VerifyLogin","11":"vendors~99designs-common-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers~pages-auth-SSO~bf16b35d","12":"vendors~components-PortfolioPage~components-ProfessionalBackgroundPage~pages-create","13":"CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","14":"PasswordStrengthBar","15":"components-PersonalInformationPage~components-ProfessionalBackgroundPage","16":"pages-account~pages-getting-started","17":"vendors~CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","18":"vendors~PasswordStrengthBar","19":"CurationUploaderAdd","20":"CurationUploaderEdit","21":"NationBuilderPreferencesPage","22":"PreziPreferences","23":"SquarePreferences","24":"SquarespacePreferences","25":"Uploader-DesignUploaderOverlayAdd","26":"Uploader-DesignUploaderOverlayEdit","27":"activity","28":"components-CurationSamplesPage-CurationSamplesPage","29":"components-NotificationsPage","30":"components-PasswordPage","31":"components-PersonalInformationPage","32":"components-PortfolioPage","33":"components-ProfessionalBackgroundPage","34":"components-ProfilePage","35":"components-VerificationPage","36":"components-YourLevelPage","37":"fileOverlay-FileOverlay","38":"files","40":"pages-account","41":"pages-auth-Login","42":"pages-auth-SSOLogin","43":"pages-auth-SignUp","44":"pages-auth-VerifyTwoFactor-VerifyAddPayout","45":"pages-auth-VerifyTwoFactor-VerifyLogin","46":"pages-create","47":"pages-designer","48":"pages-getting-started","49":"pages-handover-messages","50":"pages-messages","51":"pages-notifications","52":"pages-projects-ProjectsApp","53":"pages-projects-cancel-invites","54":"pages-status","55":"pages-web-get-started-WebOnboarderPage","57":"vendors~99designs-common-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers","58":"vendors~PreziPreferences","59":"vendors~SquarespacePreferences","60":"vendors~components-PortfolioPage","61":"vendors~components-ProfilePage","62":"vendors~fileOverlay-FileOverlay","63":"vendors~files","64":"vendors~pages-auth-SSOLogin","65":"vendors~pages-getting-started","66":"vendors~pages-projects-ProjectsApp","67":"vendors~pages-web-get-started-WebOnboarderPage"}[chunkId]||chunkId) + "." + {"0":"2b607a592e","1":"9620ed66d4","2":"fbeabc292d","3":"323b5e5c64","4":"d57aa0e35f","5":"045c027526","6":"e488261874","7":"2add321160","8":"0e463b3094","9":"7054924177","10":"460c34b2c3","11":"ffce1fc945","12":"1f4142f807","13":"36b7a0faf8","14":"392cbcbe55","15":"e6aceb0ff5","16":"22ed661120","17":"b8b7b29c09","18":"41b8ac114f","19":"b2f8955176","20":"70a4ac43d0","21":"caada96a44","22":"b2ce4c4e9e","23":"4c59210255","24":"cec2c66d47","25":"2420b885c9","26":"6c1af0262b","27":"d07baf021b","28":"ec24d6cc97","29":"3fc10566df","30":"59e0af5579","31":"f453c8238e","32":"c0be92db0e","33":"27a9c871a3","34":"d934c1ae49","35":"9bd9268e9e","36":"d20f48ed40","37":"2a208a6258","38":"fdbdd76644","40":"2ed8df9a27","41":"af209ef265","42":"c98efd22da","43":"5941afb384","44":"29c7ae0a9f","45":"dc2874f1bc","46":"2b05447af2","47":"8d6411713e","48":"ffaabaaffb","49":"424ce863c6","50":"83fa621023","51":"886322f677","52":"986711f7ee","53":"8d8230e132","54":"95b2a74c50","55":"f6f1e75dab","57":"ed1aa0f8e6","58":"8ae27b3bb4","59":"1501930ba0","60":"81378670a1","61":"c76b9c9ae2","62":"320124dabc","63":"2f00230d7b","64":"aa7ddff481","65":"0ac33db41a","66":"2ab561aa47","67":"9766e528d4"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.99static.com/spa/client/en/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 376);
